export default async function cleanErrors() {
  return { content: true };
}
